import { ReactNode } from 'react';
import { Result } from 'antd';
import { Role, useRoleClaim } from '../auth/useRoleClaim';

interface Props {
  /** Roles allowed to see the children. Empty = no one. */
  allow: Role[];
  /** Renders when the role is not allowed. Default: a 403 panel. */
  fallback?: ReactNode;
  children: ReactNode;
}

/**
 * Client-side role gate. UX-only — the server re-checks every
 * request, so a tampered client can't access anything they
 * shouldn't. The fallback is shown when the user's role isn't in
 * `allow`. `null` role (token claim missing) also falls back.
 */
export function RoleGuard({ allow, fallback, children }: Props) {
  const { role } = useRoleClaim();
  if (role && allow.includes(role)) return <>{children}</>;
  if (fallback !== undefined) return <>{fallback}</>;
  return (
    <Result
      status="403"
      title="Not authorized"
      subTitle="Your account doesn't have permission for this view."
    />
  );
}
